import semver from 'semver'

import { output } from '@/helpers/std-out'

export function checkNodeVersion() {
  const currentVersion = process.version

  if (!semver.satisfies(currentVersion, import.meta.env.MINIMUM_NODE_VERSION)) {
    output
      .error()
      .title('Node.js version incompatible')
      .message(
        `Current Node.js version: ${currentVersion}\nMinimum required version: ${import.meta.env.MINIMUM_NODE_VERSION}\nPlease upgrade your Node.js version and try again.\nVisit https://nodejs.org to download the latest version.`,
      )
      .exit('error')
  }
}
